if (typeof window.candidateInfo === 'undefined') {
    window.candidateInfo = {};
}
// axios.get(environment.candidateUri + "118").then(
//     (response) => {
//         //Stop loading
//         // setLoading(false);
//         window.candidateInfo = response.data;
//         // setCandidate(response.data);
//         console.log(window.candidateInfo);
//     },
//     () => {
//         window.candidateInfo = {};
//         //Stop loading
//         // setLoading(false);
//     }
// );
export default window.candidateInfo;